// extracted by mini-css-extract-plugin
module.exports = {"questionnaire":"style_questionnaire__2iEVK"};